import React from 'react';
import { connect } from 'react-redux';

class Skills extends React.Component{

    render(){
        let skills = []
        if (typeof this.props.skillsList !== undefined && this.props.skillsList.length > 0) {
            //Sort it by Id
            // this.props.skillsList.sort((a, b) => {
            //     return a.id.localeCompare(b.id);
            // });
            this.props.skillsList.sort((a, b) => { return a.id - b.id; });
            
            skills = this.props.skillsList.map((skill) => {

                return  <div key={skill.id} className="o-grid__col-sm-3">
                    <div className="o-media  o-media--block  o-content">
                        <div className="o-media__figure">
                            <div className="c-number  t-primary-color">
                                {skill.id}
                            </div>
                        </div>
                        <div className="o-media__body  o-content__body">
                            <h3>{skill.name}</h3>
                        </div>
                    </div>
                </div>

            });
        }

        return(

            <section className="o-section  t-section  ">

                <div className="o-section__header-bg  t-section__header"></div>
                <div className="o-section__content-bg  t-section__content"></div>

                <div className="o-container">
                    <div className="o-section__container">

                        <header className="o-section__header  t-section__header">
                            <div className="o-content">
                                <h2 className="o-section__heading">
                                    Skills
                                </h2>
                                <div className="o-content__body  o-section__description">
                                    
                                </div>
                            </div>
                        </header>

                        <div className="o-section__content  t-section__content  ">

                            <div className="o-grid">
                                {skills}
                            </div>

                        </div>

                    </div>
                </div>

            </section> 



        );
    }
}

const mapStateToProps = (state) => {
    return {
        skillsList: state.skills.skillsList
    };
};

export default connect(mapStateToProps)(Skills);


// WEBPACK FOOTER //
// ./src/components/Skills.js